import React from "react"
import type { AvaliacaoDeliveryModel } from "../models/avaliacaoDeliveryModel"
import { AvaliacaoDeliveryInicial } from "../models/avaliacaoDeliveryModel"
import type { AvaliacaoDeliveryActionModel } from "./avaliacaoDeliveryActions"

type AvaliacaoDeliveryContextType = {
    dados: AvaliacaoDeliveryModel
    dispatch: React.Dispatch<AvaliacaoDeliveryActionModel>
    pesquisar: (inicio?: number, fim?: number) => Promise<void>
    erroCarregamento: string | null
}

export const AvaliacaoDeliveryContext = React.createContext<AvaliacaoDeliveryContextType>({
    dados: AvaliacaoDeliveryInicial,
    dispatch: () => undefined,
    pesquisar: async () => undefined,
    erroCarregamento: null,
})
